/**
 * InPost Geowidget v5 (PL Market) \u2014 modal globalny, integracja z koszykiem Shopify (Horizon)
 *
 * Dokumentacja:
 * https://dokumentacja-inpost.atlassian.net/wiki/spaces/PL/pages/50069505/Geowidget+v5+PL+Market
 *
 * Token: wpisz w atrybucie data-inpost-geowidget-token na wrapperze
 * w snippets/cart-inpost-geowidget.liquid w miejscu PUBLIC_INPOST_GEOWIDGET_TOKEN_HERE
 * NIE wklejaj ShipX ID ani ShipX Token.
 */

(function () {
  'use strict';

  var GEOWIDGET_JS_URL  = 'https://geowidget.inpost.pl/inpost-geowidget.js';
  var GEOWIDGET_CSS_URL = 'https://geowidget.inpost.pl/inpost-geowidget.css';
  var FIELD_NAME        = 'attributes[Numer Paczkomatu InPost]';
  var CART_ATTR_NAME    = 'Numer Paczkomatu InPost';
  var MODAL_ATTR        = 'data-inpost-modal';

  var scriptLoaded  = false;
  var scriptLoading = false;
  var activeGeowidgetWrapper = null;

  // =========================================================================
  // MECHANIZM ZAPISU
  // =========================================================================

  var lastSavedValue  = null;
  var desiredValue    = null;
  var desiredPole     = null;
  var activeSaveValue = null;
  var saveChain       = Promise.resolve();
  var domInitialized  = false;

  // =========================================================================
  // STAN WYSZUKIWANIA
  // =========================================================================

  var lookupSeq           = 0;
  var lookupAbort         = null;
  var lookupTimer         = null;
  var activeCode          = '';
  var activeLookupPromise = null;

  // =========================================================================
  // STAN PER-POLE
  // fieldDrafts: klucz istnieje = szkic aktywny (mo\u017ce by\u0107 pusty string = celowe skasowanie)
  //              brak klucza   = brak szkicu
  // =========================================================================

  var fieldDrafts  = {};
  var fieldFocused = {};

  // =========================================================================
  // CSS MODALU
  // =========================================================================

  var MODAL_CSS = [
    '[data-inpost-modal]{',
      'position:fixed!important;inset:0!important;z-index:2147483647!important;',
      'display:flex;align-items:center;justify-content:center;',
    '}',
    '[data-inpost-modal-overlay]{',
      'position:absolute;inset:0;background:rgba(0,0,0,0.55);',
    '}',
    '.inpost-modal__window{',
      'position:relative;z-index:1;background:#fff;border-radius:8px;',
      'width:min(960px,95vw);height:min(700px,90vh);',
      'display:flex;flex-direction:column;overflow:hidden;',
      'box-shadow:0 8px 40px rgba(0,0,0,0.25);',
    '}',
    '.inpost-modal__header{',
      'display:flex;align-items:center;justify-content:space-between;',
      'padding:0.85rem 1.25rem;border-bottom:1px solid #e5e5e5;flex-shrink:0;',
    '}',
    '.inpost-modal__title{font-size:1rem;font-weight:600;}',
    '.inpost-modal__close{',
      'background:none;border:none;font-size:1.25rem;cursor:pointer;',
      'padding:0.25rem 0.5rem;line-height:1;color:inherit;opacity:0.6;',
    '}',
    '.inpost-modal__close:hover{opacity:1;}',
    '.inpost-modal__body{',
      'flex:1;overflow:hidden;display:flex;flex-direction:column;',
    '}',
    '.inpost-modal__body inpost-geowidget{',
      'flex:1;display:block;width:100%;height:100%;min-height:0;',
    '}',
    '@media(max-width:600px){',
      '[data-inpost-modal]{align-items:flex-end!important;}',
      '.inpost-modal__window{',
        'width:100vw!important;',
        'height:92vh!important;',
        'max-height:92vh!important;',
        'border-radius:12px 12px 0 0!important;',
      '}',
    '}',
    '@supports (height:1dvh){',
      '@media(max-width:600px){',
        '.inpost-modal__window{',
          'height:92dvh!important;',
          'max-height:92dvh!important;',
        '}',
      '}',
    '}',
    '.inpost-modal__body inpost-geowidget::part(language-switcher),',
    '.inpost-modal__body .inpost-geowidget__language-switcher,',
    '.inpost-modal__body [class*="language-switcher"],',
    '.inpost-modal__body [class*="languageSwitcher"]{display:none!important;}',
    'body.inpost-modal-open{overflow:hidden;}'
  ].join('');

  // =========================================================================
  // POMOCNICZE
  // =========================================================================

  function fieldId(pole) {
    return pole.id || pole.name || FIELD_NAME;
  }

  // Znajd\u017a aktualne pole w DOM \u2014 odporne na morphing
  function resolveCurrentPole(pole) {
    if (pole && document.contains(pole)) { return pole; }
    var fid = pole ? (pole.id || '') : '';
    if (fid) {
      var byId = document.getElementById(fid);
      if (byId && byId.name === FIELD_NAME) { return byId; }
    }
    return (
      document.querySelector('.cart-paczkomat--drawer [name="' + FIELD_NAME + '"]') ||
      document.querySelector('.cart-paczkomat--page [name="' + FIELD_NAME + '"]') ||
      null
    );
  }

  function showFieldError(pole, msg) {
    var current = resolveCurrentPole(pole);
    if (!current) { return; }
    clearFieldError(current);
    var err = document.createElement('p');
    err.className = 'cart-paczkomat__input-error';
    err.setAttribute('role', 'alert');
    err.style.cssText = 'font-size:0.75rem;color:#c0392b;margin:0.25rem 0 0;line-height:1.4;';
    err.textContent = msg;
    current.insertAdjacentElement('afterend', err);
  }

  function clearFieldError(pole) {
    var current = resolveCurrentPole(pole);
    if (!current) { return; }
    var err = current.parentNode && current.parentNode.querySelector('.cart-paczkomat__input-error');
    if (err) { err.remove(); }
  }

  function extractCode(raw) {
    var idx = (raw || '').indexOf(' \u2014 ');
    return (idx !== -1 ? raw.slice(0, idx) : raw).trim().toUpperCase();
  }

  function looksLikePointCode(str) {
    return /^[A-Z0-9]{5,12}$/.test(str);
  }

  function buildAddressFromApi(addr) {
    var line1 = (addr.line1 || '').trim();
    var line2 = (addr.line2 || '').trim();
    var parts = [];
    if (line1) { parts.push(line1); }
    if (line2) { parts.push(line2); }
    return parts.join(', ');
  }

  // =========================================================================
  // JEDYNE WYWOÅANIE saveCartAttribute â€” wewnÄ…trz _doSave()
  // =========================================================================

  function saveCartAttribute(value) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root : '/';
    var body = { attributes: {} };
    body.attributes[CART_ATTR_NAME] = value;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart/update.js zwr\u00f3ci\u0142 b\u0142\u0105d: ' + response.status);
      }
      return response.json();
    });
  }

  function _doSave() {
    var valueToSave = desiredValue;
    var poleToSave  = desiredPole;

    if (valueToSave === lastSavedValue) {
      activeSaveValue = null;
      return Promise.resolve();
    }

    activeSaveValue = valueToSave;

    return saveCartAttribute(valueToSave)
      .then(function () {
        lastSavedValue  = valueToSave;
        activeSaveValue = null;

        if (desiredValue !== valueToSave) {
          return _doSave();
        }

        _applyToDOM(valueToSave, poleToSave);
      })
      .catch(function (err) {
        activeSaveValue = null;
        console.error('[InPost Geowidget] B\u0142\u0105d zapisu do koszyka:', err);
        updateDrawerPanel(lastSavedValue || '');
        showFieldError(poleToSave, 'Nie uda\u0142o si\u0119 zapisa\u0107 Paczkomatu. Spr\u00f3buj ponownie.');

        if (desiredValue !== valueToSave) {
          return _doSave();
        }
      });
  }

  function _applyToDOM(value, pole) {
    var current = resolveCurrentPole(pole);
    if (!current) { return; }

    var fid      = fieldId(current);
    var hasDraft = Object.prototype.hasOwnProperty.call(fieldDrafts, fid);
    var currentDraft = hasDraft ? fieldDrafts[fid] : null;

    if (
      !hasDraft ||
      currentDraft === null ||
      extractCode(currentDraft) === extractCode(value)
    ) {
      delete fieldDrafts[fid];
      current.value = value;
    }

    syncAllFields(value, current);
    updateDrawerPanel(value);
    clearFieldError(current);
    console.log('[InPost Geowidget] Paczkomat zapisany w koszyku:', value);
  }

  // =========================================================================
  // CENTRALNA FUNKCJA ZAPISU
  // =========================================================================

  function commitValue(value, pole) {
    desiredValue = value;
    desiredPole  = pole;

    if (activeSaveValue === null) {
      saveChain = saveChain.then(function () {
        return _doSave();
      });
    }

    return saveChain;
  }

  function clearPoint(pole) {
    return commitValue('', pole);
  }

  // =========================================================================
  // WYSZUKIWANIE PUNKTU W API INPOST
  // =========================================================================

  function doLookup(code) {
    if (activeCode === code && activeLookupPromise) {
      return activeLookupPromise;
    }
    if (lookupAbort) { lookupAbort.abort(); }
    lookupAbort = new AbortController();
    activeCode  = code;
    var mySeq   = ++lookupSeq;
    var signal  = lookupAbort.signal;

    activeLookupPromise = fetch(
      'https://api-shipx-pl.easypack24.net/v1/points/' + encodeURIComponent(code),
      { headers: { 'Accept': 'application/json' }, signal: signal }
    )
      .then(function (res) {
        if (mySeq !== lookupSeq) { return null; }
        if (res.status === 404) { return { _error: 'not_found' }; }
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      })
      .then(function (data) {
        if (!data) { return null; }
        if (data._error) { return data; }
        if (mySeq !== lookupSeq) { return null; }
        if (!data.name || data.name.toUpperCase() !== code) {
          return { _error: 'mismatch' };
        }
        if (data.status !== 'Operating') {
          return { _error: 'not_operating', status: data.status };
        }
        var adres   = buildAddressFromApi(data.address || {});
        var wartosc = adres ? data.name + ' \u2014 ' + adres : data.name;
        return { _ok: true, value: wartosc };
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') { return null; }
        if (mySeq !== lookupSeq) { return null; }
        console.warn('[InPost Geowidget] B\u0142\u0105d wyszukiwania punktu:', err);
        return { _error: 'network' };
      })
      .finally(function () {
        if (mySeq === lookupSeq) {
          activeCode          = '';
          activeLookupPromise = null;
        }
      });

    return activeLookupPromise;
  }

  function handleLookupResult(result, code, pole) {
    if (!result) { return; }
    var current = resolveCurrentPole(pole) || pole;
    if (result._error === 'not_found') {
      showFieldError(current, 'Nie znaleziono Paczkomatu o kodzie \u201e' + code + '\u201d. Sprawd\u017a kod i spr\u00f3buj ponownie.');
      return;
    }
    if (result._error === 'mismatch') {
      showFieldError(current, 'Paczkomat \u201e' + code + '\u201d nie zosta\u0142 rozpoznany. Sprawd\u017a kod.');
      return;
    }
    if (result._error === 'not_operating') {
      showFieldError(current, 'Paczkomat \u201e' + code + '\u201d jest chwilowo niedost\u0119pny (status: ' + result.status + ').');
      return;
    }
    if (result._error === 'network') {
      showFieldError(current, 'Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107 z InPost. Spr\u00f3buj ponownie lub wybierz punkt z mapy.');
      return;
    }
    if (result._ok) {
      clearFieldError(current);
      commitValue(result.value, current);
    }
  }

  function verifyAndSave(pole) {
    var raw  = pole.value.trim();
    var code = extractCode(raw);

    clearFieldError(pole);

    if (!raw) {
      clearPoint(pole);
      return;
    }

    if (raw === desiredValue) { return; }
    if (raw === lastSavedValue && desiredValue === lastSavedValue) { return; }

    if (!looksLikePointCode(code)) {
      fieldDrafts[fieldId(pole)] = pole.value;
      showFieldError(pole, 'Nieprawid\u0142owy format kodu Paczkomatu. Przyk\u0142ad: WAW44BAPP.');
      return;
    }

    doLookup(code).then(function (result) {
      handleLookupResult(result, code, pole);
    });
  }

  // =========================================================================
  // MODAL
  // =========================================================================

  function injectModalCSS() {
    if (document.getElementById('inpost-modal-css')) return;
    var style = document.createElement('style');
    style.id = 'inpost-modal-css';
    style.textContent = MODAL_CSS;
    document.head.appendChild(style);
  }

  function getModal() {
    return document.body.querySelector(':scope > [' + MODAL_ATTR + ']');
  }

  function ensureModal(wrapper) {
    var existing = getModal();
    if (existing) { updateModalToken(existing, wrapper); return existing; }
    var modal = document.createElement('div');
    modal.setAttribute(MODAL_ATTR, '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Wybierz Paczkomat InPost');
    modal.style.display = 'none';
    modal.innerHTML = [
      '<div data-inpost-modal-overlay></div>',
      '<div class="inpost-modal__window">',
        '<div class="inpost-modal__header">',
          '<span class="inpost-modal__title">Wybierz Paczkomat</span>',
          '<button type="button" class="inpost-modal__close" data-inpost-modal-close aria-label="Zamknij">&#x2715;</button>',
        '</div>',
        '<div class="inpost-modal__body">',
          '<inpost-geowidget',
            ' data-inpost-geowidget-element',
            ' token=""',
            ' language="pl"',
            ' config="parcelCollect"',
            ' onpoint="onpointselect"',
          '></inpost-geowidget>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);
    bindModalEvents(modal);
    updateModalToken(modal, wrapper);
    return modal;
  }

  function updateModalToken(modal, wrapper) {
    var token = wrapper ? (wrapper.getAttribute('data-inpost-geowidget-token') || '') : '';
    var geoEl = modal.querySelector('[data-inpost-geowidget-element]');
    if (geoEl && token) { geoEl.setAttribute('token', token); }
  }

  function reopenCartDrawer() {
    var cartTrigger =
      document.querySelector('cart-drawer-component [data-testid="cart-drawer-trigger"]') ||
      document.querySelector('cart-drawer-component button[aria-label="Koszyk"]');
    if (cartTrigger) { cartTrigger.click(); }
  }

  function openModal(wrapper) {
    injectModalCSS();
    activeGeowidgetWrapper = wrapper;
    var closeButton = document.querySelector('.cart-drawer__close-button');
    if (closeButton) { closeButton.click(); }
    window.setTimeout(function () {
      var modal = ensureModal(wrapper);
      document.body.appendChild(modal);
      modal.style.position = 'fixed';
      modal.style.inset = '0';
      modal.style.zIndex = '2147483647';
      modal.style.display = 'flex';
      document.body.classList.add('inpost-modal-open');
      var trigger = wrapper.querySelector('[data-inpost-geowidget-trigger]');
      if (trigger) { trigger.setAttribute('aria-expanded', 'true'); }
      requestAnimationFrame(function () {
        var rect = modal.getBoundingClientRect();
        console.log('[InPost Geowidget] Modal opened', rect);
        if (rect.width === 0 || rect.height === 0) {
          console.warn('[InPost Geowidget] Modal ma zerowe wymiary \u2014 problem z CSS!');
        }
      });
      loadAssets(function () { bindPointListener(); });
    }, 300);
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.style.display = 'none';
    document.body.classList.remove('inpost-modal-open');
    if (activeGeowidgetWrapper) {
      var trigger = activeGeowidgetWrapper.querySelector('[data-inpost-geowidget-trigger]');
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); }
    }
    activeGeowidgetWrapper = null;
  }

  function bindModalEvents(modal) {
    var overlay = modal.querySelector('[data-inpost-modal-overlay]');
    if (overlay) { overlay.addEventListener('click', closeModal); }
    var closeBtn = modal.querySelector('[data-inpost-modal-close]');
    if (closeBtn) { closeBtn.addEventListener('click', closeModal); }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') { closeModal(); }
    });
  }

  // =========================================================================
  // SYNCHRONIZACJA POLA I PANELU
  // =========================================================================

  function buildFieldValue(details) {
    var numer = (details.name || '').trim();
    if (!numer) return null;
    var adres = buildAddressFromApi(details.address || {});
    return adres ? numer + ' \u2014 ' + adres : numer;
  }

  function syncAllFields(value, sourcePole) {
    var allFields = document.querySelectorAll('[name="' + FIELD_NAME + '"]');
    allFields.forEach(function (field) {
      if (field === sourcePole) { return; }
      var fid      = fieldId(field);
      var hasDraft = Object.prototype.hasOwnProperty.call(fieldDrafts, fid);
      if (hasDraft && extractCode(fieldDrafts[fid]) !== extractCode(value)) { return; }
      field.value = value;
      delete fieldDrafts[fid];
    });
  }

  function updateDrawerPanel(value) {
    var drawerWrapper = document.querySelector('.cart-paczkomat--drawer');
    if (!drawerWrapper) return;
    var hasPoint = value && value.trim().length > 0;
    var parts    = hasPoint ? value.split(' \u2014 ') : [];
    var kod      = hasPoint ? (parts[0] || '').trim() : '';
    var adres    = hasPoint ? (parts[1] || '').trim() : '';
    var statusLabel   = drawerWrapper.querySelector('.cart-paczkomat__status-label');
    var statusSub     = drawerWrapper.querySelector('.cart-paczkomat__status-sub');
    var statusAddress = drawerWrapper.querySelector('.cart-paczkomat__status-address');
    var skipEl        = drawerWrapper.querySelector('.cart-paczkomat__skip');
    var btn           = drawerWrapper.querySelector('[data-inpost-geowidget-trigger]');
    if (hasPoint) {
      if (statusLabel) {
        statusLabel.textContent = 'Paczkomat: ';
        var strong = document.createElement('strong');
        strong.textContent = kod;
        statusLabel.appendChild(strong);
      }
      if (statusSub)     { statusSub.hidden = true; }
      if (statusAddress) { statusAddress.textContent = adres; statusAddress.hidden = !adres; }
      if (skipEl) { skipEl.hidden = true; }
      if (btn)    { btn.textContent = 'Zmie\u0144'; }
    } else {
      if (statusLabel)   { statusLabel.textContent = 'Paczkomat InPost'; }
      if (statusSub)     { statusSub.hidden = false; }
      if (statusAddress) { statusAddress.hidden = true; }
      if (skipEl) { skipEl.hidden = false; }
      if (btn)    { btn.textContent = 'Wybierz Paczkomat'; }
    }
  }

  // =========================================================================
  // WYBÃ“R Z MAPY
  // =========================================================================

  var pointListenerBound = false;

  function bindPointListener() {
    if (pointListenerBound) return;
    pointListenerBound = true;
    document.addEventListener('onpointselect', function (event) {
      try {
        var details = event.details || event.detail || {};
        var wartosc = buildFieldValue(details);
        if (wartosc === null) {
          console.warn('[InPost Geowidget] Wybrano punkt bez numeru \u2014 pole pozostaje bez zmian.', details);
          return;
        }

        clearTimeout(lookupTimer);
        if (lookupAbort) { lookupAbort.abort(); lookupAbort = null; }
        ++lookupSeq;
        activeCode          = '';
        activeLookupPromise = null;

        // Wyczy\u015b\u0107 wszystkie szkice \u2014 mapa zast\u0119puje r\u0119czny wpis
        Object.keys(fieldDrafts).forEach(function (k) { delete fieldDrafts[k]; });

        var wrapper = null;
        if (event.target && typeof event.target.closest === 'function') {
          wrapper = event.target.closest('[data-inpost-geowidget-wrapper]');
        }
        if (!wrapper && activeGeowidgetWrapper && document.body.contains(activeGeowidgetWrapper)) {
          wrapper = activeGeowidgetWrapper;
        }
        if (!wrapper) {
          wrapper = document.querySelector('[data-inpost-geowidget-wrapper]');
        }

        var pole = null;
        if (wrapper) {
          var lokalnyKontener = wrapper.closest('.cart-paczkomat');
          if (lokalnyKontener) {
            pole = lokalnyKontener.querySelector('[name="' + FIELD_NAME + '"]');
          }
        }
        if (!pole) { pole = document.querySelector('[name="' + FIELD_NAME + '"]'); }
        if (!pole) {
          console.warn('[InPost Geowidget] Nie znaleziono pola Paczkomatu w DOM.');
          return;
        }

        closeModal();

        commitValue(wartosc, pole).finally(function () {
          reopenCartDrawer();
        });

      } catch (e) {
        console.error('[InPost Geowidget] B\u0142\u0105d obs\u0142ugi onpointselect:', e);
      }
    });
  }

  // =========================================================================
  // RÄ˜CZNE WPISYWANIE
  // =========================================================================

  function bindManualFieldSave() {

    document.addEventListener('input', function (e) {
      if (!e.isTrusted) { return; }
      var pole = e.target;
      if (!pole || pole.name !== FIELD_NAME) { return; }

      var fid = fieldId(pole);
      fieldDrafts[fid] = pole.value;   // klucz istnieje = szkic aktywny (mo\u017ce by\u0107 '')
      clearFieldError(pole);
      clearTimeout(lookupTimer);

      var code = extractCode(pole.value.trim());
      if (code !== activeCode) {
        if (lookupAbort) { lookupAbort.abort(); lookupAbort = null; }
        ++lookupSeq;
        activeCode          = '';
        activeLookupPromise = null;
      }

      if (pole.value.trim() && looksLikePointCode(code)) {
        lookupTimer = setTimeout(function () {
          var currentPole =
            document.querySelector('.cart-paczkomat--drawer [name="' + FIELD_NAME + '"]') ||
            document.querySelector('[name="' + FIELD_NAME + '"]');
          if (!currentPole) { return; }
          if (extractCode(currentPole.value.trim()) !== code) { return; }
          doLookup(code).then(function (result) {
            handleLookupResult(result, code, currentPole);
          });
        }, 600);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') { return; }
      var pole = e.target;
      if (!pole || pole.name !== FIELD_NAME) { return; }
      e.preventDefault();
      clearTimeout(lookupTimer);
      var code = extractCode(pole.value.trim());
      if (looksLikePointCode(code) && activeCode === code && activeLookupPromise) {
        activeLookupPromise.then(function (result) {
          handleLookupResult(result, code, pole);
        });
      } else {
        verifyAndSave(pole);
      }
    });

    document.addEventListener('blur', function (e) {
      var pole = e.target;
      if (!pole || pole.name !== FIELD_NAME) { return; }
      clearTimeout(lookupTimer);
      var code = extractCode(pole.value.trim());
      if (looksLikePointCode(code) && activeCode === code && activeLookupPromise) {
        activeLookupPromise.then(function (result) {
          handleLookupResult(result, code, pole);
        });
      } else {
        verifyAndSave(pole);
      }
      fieldFocused[fieldId(pole)] = false;
    }, true);

    document.addEventListener('focus', function (e) {
      var pole = e.target;
      if (!pole || pole.name !== FIELD_NAME) { return; }
      var fid = fieldId(pole);
      if (pole.value && !fieldFocused[fid]) {
        fieldFocused[fid] = true;
        requestAnimationFrame(function () { pole.select(); });
      }
    }, true);

  }

  // =========================================================================
  // ÅADOWANIE ZASOBÃ“W
  // =========================================================================

  function loadAssets(callback) {
    if (scriptLoaded) { callback(); return; }
    if (scriptLoading) {
      var interval = setInterval(function () {
        if (scriptLoaded) { clearInterval(interval); callback(); }
      }, 100);
      return;
    }
    scriptLoading = true;
    if (!document.querySelector('link[href="' + GEOWIDGET_CSS_URL + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = GEOWIDGET_CSS_URL;
      document.head.appendChild(link);
    }
    var script = document.createElement('script');
    script.src = GEOWIDGET_JS_URL;
    script.async = true;
    script.onload = function () { scriptLoaded = true; scriptLoading = false; callback(); };
    script.onerror = function () {
      scriptLoading = false;
      console.warn('[InPost Geowidget] Nie uda\u0142o si\u0119 za\u0142adowa\u0107 skryptu InPost.');
    };
    document.head.appendChild(script);
  }

  // =========================================================================
  // BINDOWANIE PRZYCISKÃ“W
  // =========================================================================

  function bindButton(wrapper) {
    if (wrapper.dataset.geowidgetBound === 'true') return;
    wrapper.dataset.geowidgetBound = 'true';
    var btn = wrapper.querySelector('[data-inpost-geowidget-trigger]');
    if (!btn) return;
    btn.addEventListener('click', function () { openModal(wrapper); });
  }

  function bindAll() {
    document.querySelectorAll('[data-inpost-geowidget-wrapper]').forEach(bindButton);
  }

  // =========================================================================
  // RE-RENDER
  // =========================================================================

  function restoreAfterRender() {
    bindAll();

    var contexts = [
      document.querySelector('.cart-paczkomat--drawer'),
      document.querySelector('.cart-paczkomat--page')
    ];

    contexts.forEach(function (ctx) {
      if (!ctx) { return; }
      var pole = ctx.querySelector('[name="' + FIELD_NAME + '"]');
      if (!pole) { return; }

      var fid      = fieldId(pole);
      var hasDraft = Object.prototype.hasOwnProperty.call(fieldDrafts, fid);

      if (!domInitialized) {
        lastSavedValue = pole.value || '';
        desiredValue   = lastSavedValue;
        domInitialized = true;
      }

      if (hasDraft) {
        // Szkic istnieje (mo\u017ce by\u0107 pusty \u2014 celowe skasowanie pola)
        pole.value = fieldDrafts[fid];
      } else if (activeSaveValue !== null) {
        // Zapis w toku \u2014 poka\u017c najnowsz\u0105 \u017c\u0105dan\u0105 warto\u015b\u0107, nie stary HTML
        pole.value = desiredValue !== null ? desiredValue : (lastSavedValue || '');
      } else {
        // Brak szkicu, brak zapisu \u2014 przywr\u00f3\u0107 potwierdzon\u0105 warto\u015b\u0107
        pole.value = lastSavedValue || '';
        updateDrawerPanel(lastSavedValue || '');
      }

      fieldFocused[fid] = false;
    });
  }

  function setupObservers() {
    ['cart:update', 'shopify:section:load'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(restoreAfterRender, 150); });
    });

    var observer = new MutationObserver(function (mutations) {
      var shouldRestore = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (
              node.hasAttribute('data-inpost-geowidget-wrapper') ||
              (node.querySelector && node.querySelector('[data-inpost-geowidget-wrapper]')) ||
              node.classList.contains('cart-paczkomat--drawer') ||
              (node.querySelector && node.querySelector('.cart-paczkomat--drawer'))
            )
          );
        });
      });
      if (shouldRestore) { setTimeout(restoreAfterRender, 150); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // =========================================================================
  // INICJALIZACJA
  // =========================================================================

  function init() {
    bindAll();
    bindManualFieldSave();
    setupObservers();
    restoreAfterRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();